<script lang="ts" setup>
defineProps({
  title: { type: String, default: 'Êtes-vous sûr(e) ?' },
  content: { type: String, required: false, default: '' },
  confirmLabel: { type: String, default: 'Confirmer' },
  cancelLabel: { type: String, default: 'Annuler' },
})

defineEmits(['cancel', 'confirm'])
</script>

<template>
  <div class="d-flex">
    <v-dropdown :distance="10">
      <slot name="button" />
      <template #popper="{ hide }">
        <div class="container p-2">
          <div class="title-light text-center">
            <h4>{{ title }}</h4>
            <p>{{ content }}</p>
          </div>
          <div class="d-flex justify-content-between flex-row">
            <button
              class="btn btn-link"
              @click="
                $emit('cancel');
                hide()
              "
            >
              {{ cancelLabel }}
            </button>
            <button
              class="btn btn-link"
              style="margin-left: auto;"
              @click="
                $emit('confirm');
                hide()
              "
            >
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </template>
    </v-dropdown>
  </div>
</template>
